import React, { Component } from "react";
import PropTypes from "prop-types";

class LinksList extends Component {
  constructor(props) {
    super(props);

    this.state = { pages: [] };
  }

  static getDerivedStateFromProps(props, state) {
    const pages = buildPages(props.links);
    return { pages };
  }

  render() {
    return (
      <div className="row">
        {this.state.pages.map((page, index) => (
          <div
            key={index}
            className={`col-12 col-sm-${Math.ceil(
              12 / this.state.pages.length
            )}`}
          >
            {page.map((link, index) => (
              <a
                key={index}
                className={`d-block ${
                  link.child ? "text-secondary" : " text-primary h6"
                } ${!link.child && index !== 0 ? "mt-3" : ""}`}
                href={link.destination}
              >
                {link.child ? link.text : <strong>{link.text}</strong>}
              </a>
            ))}
          </div>
        ))}
      </div>
    );
    //     {this.props.links.map((link, index) => (
    //       <div className="mb-3" key={index}>
    //       </div>
    //     ))}
    //   </div>
  }
}

LinksList.propTypes = {
  links: PropTypes.array
};

export default LinksList;

/**
 * Page Builder Helper Meithod
 */
const buildPages = rawLinks => {
  return paginateLinks(normalizeLinks(rawLinks), 9);
};

/**
 * Normalise The Links Data
 */
const normalizeLinks = rawLinks => {
  const links = [];
  // map on the nested data
  rawLinks.map((link, index) => {
    // so we know its a parent link
    link.child = false;
    links.push(link);
    // normalise the children
    if (link.children) {
      link.children.map((child, i) => {
        // so we can find the parent once its paged
        child.parent = links.indexOf(link);
        child.child = true;
        links.push(child);
      });
    }
  });
  return links;
};

/**
 * Paginate our normalised List
 */
const paginateLinks = (links, limit) => {
  // build our pages
  const pages = [];
  // we have X Pages
  const numberOfPages = Math.ceil(links.length / limit);
  // Loop through the "pages" and allocate the slice
  for (var i = 0; i < numberOfPages; i++) {
    let page = links.slice(i * limit, (i + 1) * limit);
    pages.push(page);
  }
  return pages;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/MegaMenu/LinksList.js